import { render } from "./list-selector.vue?vue&type=template&id=5b349545"
import script from "./list-selector.vue?vue&type=script&lang=js"
export * from "./list-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__